(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rsg-v9-brand-family-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-brand-family-showcase]').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[data-brand-families-tab]'))
    const panels = Array.from(section.querySelectorAll('[data-brand-families-panel]'))

    const activateTab = (tab, moveFocus = false) => {
      tabs.forEach((candidate) => {
        const active = candidate === tab
        candidate.setAttribute('aria-selected', String(active))
        candidate.tabIndex = active ? 0 : -1
      })
      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls')
      })
      if (moveFocus) tab.focus()
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab))
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
        event.preventDefault()
        let nextIndex = index
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length
        if (event.key === 'Home') nextIndex = 0
        if (event.key === 'End') nextIndex = tabs.length - 1
        activateTab(tabs[nextIndex], true)
      })
    })

    section.querySelectorAll('[data-brand-family-card]').forEach((card) => {
      const select = card.querySelector('[data-brand-family-variant]')
      const hiddenInput = card.querySelector('form input[name="id"]')
      const price = card.querySelector('[data-brand-family-price]')
      const availability = card.querySelector('[data-brand-family-availability]')
      const addButton = card.querySelector('[data-brand-family-add]')
      const image = card.querySelector('[data-brand-family-image]')
      const mediaLink = card.querySelector('[data-brand-family-media-link]')
      const detailsLink = card.querySelector('[data-brand-family-details]')
      if (!select || !hiddenInput || !price || !availability || !addButton) return

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex]
        const available = option.dataset.available === 'true'
        hiddenInput.value = option.value
        price.textContent = option.dataset.price || ''
        availability.textContent = available ? section.dataset.inStockLabel : section.dataset.soldOutLabel
        addButton.disabled = !available
        addButton.textContent = available ? section.dataset.addLabel : section.dataset.soldOutLabel
        if (option.dataset.url) {
          if (mediaLink) mediaLink.href = option.dataset.url
          if (detailsLink) detailsLink.href = option.dataset.url
        }
        if (image && option.dataset.imageSrc) {
          image.removeAttribute('srcset')
          image.src = option.dataset.imageSrc
          image.alt = option.dataset.imageAlt || ''
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsg-v9-brand-product-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-brand-product-showcase]').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[data-brand-products-tab]'))
    const panels = Array.from(section.querySelectorAll('[data-brand-products-panel]'))

    const activateTab = (tab, moveFocus = false) => {
      tabs.forEach((candidate) => {
        const active = candidate === tab
        candidate.setAttribute('aria-selected', String(active))
        candidate.tabIndex = active ? 0 : -1
      })
      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls')
      })
      if (moveFocus) tab.focus()
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab))
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
        event.preventDefault()
        let nextIndex = index
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length
        if (event.key === 'Home') nextIndex = 0
        if (event.key === 'End') nextIndex = tabs.length - 1
        activateTab(tabs[nextIndex], true)
      })
    })

    const activateAnchor = (anchor) => {
      const target = panels.find((panel) => (
        panel.querySelector('[data-brand-products-anchor]')?.dataset.brandProductsAnchor === anchor
      ))
      if (!target) return false
      const tab = tabs.find((candidate) => candidate.getAttribute('aria-controls') === target.id)
      if (!tab) return false
      activateTab(tab)
      return true
    }

    const activateLocationHash = () => {
      const anchor = decodeURIComponent(window.location.hash.slice(1))
      if (anchor) activateAnchor(anchor)
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]')
      if (!link) return
      const anchor = decodeURIComponent(link.getAttribute('href').slice(1))
      if (anchor) activateAnchor(anchor)
    })

    window.addEventListener('hashchange', activateLocationHash)
    activateLocationHash()

    section.querySelectorAll('[data-brand-product-card]').forEach((card) => {
      const select = card.querySelector('[data-brand-product-variant]')
      const hiddenInput = card.querySelector('form input[name="id"]')
      const currentPrice = card.querySelector('[data-brand-product-current-price]')
      const comparePrice = card.querySelector('[data-brand-product-compare-price]')
      const availability = card.querySelector('[data-brand-product-availability]')
      const addButton = card.querySelector('[data-brand-product-add]')
      if (!select || !hiddenInput || !currentPrice || !comparePrice || !availability || !addButton) return

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex]
        const available = option.dataset.available === 'true'
        hiddenInput.value = option.value
        card.querySelectorAll('.rsg-v9-brand-products__media, .rsg-v9-brand-products__card-content h3 a, .rsg-v9-brand-products__details').forEach((link) => {
          if (option.dataset.url) link.href = option.dataset.url
        })
        currentPrice.textContent = option.dataset.price || ''
        comparePrice.textContent = option.dataset.comparePrice || ''
        comparePrice.hidden = !option.dataset.comparePrice
        availability.textContent = available ? section.dataset.inStockLabel : section.dataset.soldOutLabel
        addButton.disabled = !available
        addButton.textContent = available ? section.dataset.addLabel : section.dataset.soldOutLabel
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsg-v9-guide-article"] && !Shopify.designMode) return;
  try {
    
  function initialiseRsgV9Article(articleRoot) {
    if (!articleRoot || articleRoot.dataset.rsgV9ArticleReady === 'true') return;
    var body = articleRoot.querySelector('[data-rsg-v9-article-body]');
    var aside = articleRoot.querySelector('[data-rsg-v9-article-aside]');
    var toc = articleRoot.querySelector('[data-rsg-v9-article-toc]');
    var list = toc && toc.querySelector('ol');
    if (!body || !aside || !toc || !list) return;

    var usedIds = {};
    var headings = Array.prototype.slice.call(body.querySelectorAll('h2:not([data-rsg-toc-ignore])'));
    headings.forEach(function (heading, index) {
      var baseId = heading.id || heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'article-section-' + (index + 1);
      var uniqueId = baseId;
      var suffix = 2;
      while (usedIds[uniqueId]) {
        uniqueId = baseId + '-' + suffix;
        suffix += 1;
      }
      usedIds[uniqueId] = true;
      heading.id = uniqueId;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + uniqueId;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });

    if (headings.length < 2) aside.hidden = true;
    if (window.matchMedia('(max-width: 749px)').matches) toc.open = false;
    articleRoot.dataset.rsgV9ArticleReady = 'true';
  }

  document.querySelectorAll('[data-rsg-v9-article]').forEach(initialiseRsgV9Article);
  document.addEventListener('shopify:section:load', function (event) {
    var articleRoot = event.target.matches('[data-rsg-v9-article]')
      ? event.target
      : event.target.querySelector('[data-rsg-v9-article]');
    initialiseRsgV9Article(articleRoot);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsg-v9-ocean-bottle-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ocean-range]').forEach((section) => {
    section.querySelectorAll('[data-ocean-card]').forEach((card) => {
      const select = card.querySelector('[data-ocean-variant]')
      const input = card.querySelector('input[name="id"]')
      const price = card.querySelector('[data-ocean-price]')
      const availability = card.querySelector('[data-ocean-availability]')
      const add = card.querySelector('[data-ocean-add]')
      const image = card.querySelector('[data-ocean-image]')
      if (!select || !input || !price || !availability || !add) return
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0]
        const available = option.dataset.available === 'true'
        input.value = option.value
        price.textContent = option.dataset.price || ''
        availability.textContent = available ? section.dataset.inStockLabel : section.dataset.soldOutLabel
        add.disabled = !available
        add.textContent = available ? section.dataset.addLabel : section.dataset.soldOutLabel
        if (image && option.dataset.image) {
          image.src = option.dataset.image
          image.removeAttribute('srcset')
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsg-v9-primary-navigation"] && !Shopify.designMode) return;
  try {
    
  const initialiseRsgV9Navigation = (navigation) => {
    if (!navigation || navigation.dataset.rsgV9KeyboardReady === 'true') return;

    const shopGroups = [...navigation.querySelectorAll('[data-rsg-v9-shop-group]')];

    const setShopGroupExpanded = (group, expanded) => {
      const trigger = group.querySelector('[data-rsg-v9-shop-group-trigger]');
      const panel = group.querySelector('[data-rsg-v9-shop-group-panel]');
      if (!trigger || !panel) return;

      trigger.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
    };

    const syncShopGroups = () => {
      navigation.toggleAttribute('data-rsg-v9-shop-accordion-ready', shopGroups.length > 0);
      shopGroups.forEach((group) => setShopGroupExpanded(group, false));
    };

    shopGroups.forEach((group) => {
      const trigger = group.querySelector('[data-rsg-v9-shop-group-trigger]');
      trigger?.addEventListener('click', () => {
        const willExpand = trigger.getAttribute('aria-expanded') !== 'true';
        shopGroups.forEach((candidate) => setShopGroupExpanded(candidate, false));
        setShopGroupExpanded(group, willExpand);
      });
    });

    syncShopGroups();

    const navigationHost = navigation.closest('.shopify-section-group-header-group');
    const setCondensedState = () => {
      const condensed = Boolean(navigationHost && window.scrollY > 0 && navigationHost.getBoundingClientRect().top <= 0);
      navigation.dataset.rsgV9Condensed = String(condensed);
    };

    let navigationFrame = 0;
    const scheduleCondensedState = () => {
      if (navigationFrame) return;
      navigationFrame = requestAnimationFrame(() => {
        navigationFrame = 0;
        setCondensedState();
      });
    };
    setCondensedState();
    window.addEventListener('scroll', scheduleCondensedState, { passive: true });
    window.addEventListener('resize', scheduleCondensedState, { passive: true });

    navigation.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMenu = event.target.closest('.rsg-v9-primary-nav__details[open]');
      if (!openMenu) return;

      event.preventDefault();
      openMenu.open = false;
      openMenu.querySelector('.rsg-v9-primary-nav__trigger')?.focus();
    });

    navigation.dataset.rsgV9KeyboardReady = 'true';
  };

  if (document.documentElement.dataset.rsgV9NavigationOutsideReady !== 'true') {
    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-rsg-v9-navigation] .rsg-v9-primary-nav__details[open]').forEach((openMenu) => {
        if (openMenu.contains(event.target)) return;
        openMenu.open = false;
      });
    });
    document.documentElement.dataset.rsgV9NavigationOutsideReady = 'true';
  }

  document.querySelectorAll('[data-rsg-v9-navigation]').forEach(initialiseRsgV9Navigation);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-rsg-v9-navigation]').forEach(initialiseRsgV9Navigation);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsg-v9-resource-hub"] && !Shopify.designMode) return;
  try {
    
  const initialiseResourceHub = (root) => {
    if (!root || root.dataset.rsgResourceReady === 'true') return;
    const search = root.querySelector('[data-rsg-resource-search]');
    const cards = [...root.querySelectorAll('[data-rsg-resource-card]')];
    const filters = [...root.querySelectorAll('[data-rsg-resource-filter]')];
    const status = root.querySelector('[data-rsg-resource-status]');
    const empty = root.querySelector('[data-rsg-resource-empty]');
    const reset = root.querySelector('[data-rsg-resource-reset]');
    if (!search || !cards.length || !filters.length || !status || !empty || !reset) return;

    let activeCategory = 'all';
    const update = () => {
      const term = search.value.trim().toLocaleLowerCase();
      let shown = 0;
      cards.forEach((card) => {
        const categoryMatches = activeCategory === 'all' || card.dataset.category === activeCategory;
        const textMatches = !term || card.dataset.searchText.includes(term);
        const visible = categoryMatches && textMatches;
        card.hidden = !visible;
        if (visible) shown += 1;
      });
      const noun = shown === 1 ? root.dataset.guideSingular : root.dataset.guidePlural;
      status.textContent = `${shown} ${noun}`;
      empty.hidden = shown !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeCategory = button.dataset.rsgResourceFilter;
        filters.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
        update();
      });
    });
    search.addEventListener('input', update);
    reset.addEventListener('click', () => {
      activeCategory = 'all';
      search.value = '';
      filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.rsgResourceFilter === 'all')));
      search.focus();
      update();
    });
    root.dataset.rsgResourceReady = 'true';
    update();
  };

  document.querySelectorAll('[data-rsg-resource-hub]').forEach(initialiseResourceHub);
  document.addEventListener('shopify:section:load', (event) => initialiseResourceHub(event.target.querySelector('[data-rsg-resource-hub]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsg-v9-tailwind-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rsg-tailwind-collection').forEach((section) => {
    const families = Array.from(section.querySelectorAll('[data-tailwind-family]'))
    const buttons = Array.from(section.querySelectorAll('[data-tailwind-filter]'))

    const applyFilter = (family) => {
      families.forEach((group) => {
        group.hidden = group.dataset.tailwindFamily !== family
      })
      buttons.forEach((button) => {
        const isActive = button.dataset.tailwindFilter === family
        button.classList.toggle('is-active', isActive)
        button.setAttribute('aria-pressed', String(isActive))
      })
    }

    buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.tailwindFilter)))
    applyFilter('endurance')
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsg-v9-tailwind-pdp"] && !Shopify.designMode) return;
  try {
    
  if (!window.rsgTailwindFuelFactsBridge) {
    window.rsgTailwindFuelFactsBridge = true
    document.addEventListener('tailwind:variant-change', (event) => {
      const purchase = event.target?.closest?.('rsg-tailwind-purchase')
      const scope = purchase?.closest?.('.rsg-tailwind-pdp')
      const controller = scope?.querySelector?.('[data-rsg-fuel-facts]')
      const option = purchase?.querySelector?.('[data-tailwind-variant]')?.selectedOptions?.[0]
      const variantId = option?.value
      if (!controller || !variantId) return
      let catalogue = {}
      try {
        catalogue = JSON.parse(controller.querySelector('[data-rsg-fuel-facts-catalogue]')?.textContent || '{}')
      } catch (_) {
        catalogue = {}
      }
      const record = catalogue[String(variantId)]
      const expectedCaffeine = option.dataset.caffeine === '1' ? 'contains' : 'free'
      if (!record || record.caffeineFilter !== expectedCaffeine) {
        const summary = controller.querySelector('[data-rsg-fuel-facts-summary]')
        const detail = controller.querySelector('[data-rsg-fuel-facts-detail]')
        if (summary) summary.hidden = true
        if (detail) detail.hidden = true
        controller.dataset.currentVariantId = ''
        return
      }
      document.dispatchEvent(new CustomEvent(
        `variant:change:${controller.dataset.sectionId}:${controller.dataset.productId}`,
        { detail: { variant: { id: variantId } } }
      ))
    })
  }

  } catch(e) { console.error(e); }
})();
})();
